import AppError from '../error/AppError';

export default class ObjectDoesNotExistError extends AppError {}


// WEBPACK FOOTER //
// ./code/foundation/repository/ObjectDoesNotExistError.ts